// extracted by mini-css-extract-plugin
export default {"root":"PasswordLabel_root__3f4SV","iconWrapper":"PasswordLabel_iconWrapper__yeYoD"};